import { RoutePath } from '../../constants';

export const isOrgSwitcherRedirectAllowed = (searchParams: URLSearchParams, pathname: string): boolean => {
  const email = searchParams.get('email') || '';
  const token = searchParams.get('token') || '';

  return !(pathname.includes(RoutePath.LOGIN) && email && token);
};
